import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';
import { CheckboxLabelSize } from './index';

export interface CheckboxDriver extends BaseDriver {
  click: () => void;
  focus: () => void;
  isFocused: () => boolean;
  blur: () => void;
  isChecked(): boolean;
  isDisabled(): boolean;
  isIndeterminate(): boolean;
  isTooltipEnabled(): Promise<boolean>;
  hasError(): boolean;
  getLabel(): string;
  getLabelSize(): CheckboxLabelSize;
  getTooltipContent(): Promise<string>;
}
